import L from "leaflet";
import React, { useEffect, useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import DetailButton from "src/components/DetailButton";
import Title from "src/components/Title";
import API from "src/services/api";

function OSMapAction({ items }) {
  // Leaflet Default-Icon Fix für React
  const defaultIcon = L.icon({
    iconUrl: "/marker-icon.png",
    shadowUrl: "/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
  });
  L.Marker.prototype.options.icon = defaultIcon;

  const map = useMap();

  useEffect(() => {
    const handleResize = () => {
      setTimeout(() => {
        map.invalidateSize();
      }, 200);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [map]);

  map.invalidateSize();

  if (items === null || items.length <= 0) {
    return null;
  }

  return items.map((i) => (
    <Marker key={i.id} position={[i.latitude, i.longitude]}>
      <Popup>
        <b>{i.name}</b>
        <br />
        <DetailButton url={`/swipe/${i.id}`} openInNewWindow={true} />
      </Popup>
    </Marker>
  ));
}

const MapSite = () => {
  const [data, setData] = useState([]);
  const [selectedOption, setSelectedOption] = useState("LIVE");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      try {
        const d = await API.getMapSwipes(selectedOption);
        if (d.data) {
          setData(d.data);
        }
      } finally {
        setIsLoading(false);
      }
    };
    loadData();
  }, [selectedOption]);

  return (
    <React.Fragment>
      <Row className="g-3 align-items-end" style={{ marginBottom: "20px" }}>
        <Col md={8}>
          <Title>Karte</Title>
        </Col>
        <Col md={4}>
          <Form.Group controlId="kpiDateRange">
            <Form.Label>Filter</Form.Label>
            <Form.Select
              value={selectedOption}
              onChange={(event) => setSelectedOption(event.target.value)}
            >
              <option key="ALL" value="ALL">
                Alle
              </option>
              <option key="LIVE" value="LIVE">
                Nur Live
              </option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col>
          {isLoading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "600px" }}
            >
              <Spinner animation="border" role="status" />
            </div>
          ) : (
            <div style={{ height: "600px", width: "100%" }}>
              <MapContainer
                center={[46.8, 7.3]}
                zoom={10}
                scrollWheelZoom={false}
                style={{ height: "600px", width: "100%" }}
              >
                <OSMapAction items={data} />
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
              </MapContainer>
            </div>
          )}
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default MapSite;
